import { render, staticRenderFns } from "./OperationResource.vue?vue&type=template&id=c3448264&lang=pug"
import script from "./OperationResource.vue?vue&type=script&lang=js"
export * from "./OperationResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports